"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAccessLevelQuery = exports.useAccessLevel = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const globalTypes_1 = require("../__types__/globalTypes");
const orderedAcls = {
    [globalTypes_1.SystemUserAcl.reader]: 1,
    [globalTypes_1.SystemUserAcl.writer]: 2,
    [globalTypes_1.SystemUserAcl.installer]: 3,
    [globalTypes_1.SystemUserAcl.manager]: 4,
    [globalTypes_1.SystemUserAcl.admin]: 5,
};
function useAccessLevel(locationId) {
    var _a, _b;
    const { data, loading, error } = client_1.useQuery(GET_ACCESS_LEVEL_QUERY, {
        variables: { locationId },
        context: { locationId },
        fetchPolicy: 'cache-first',
    });
    const isAtLeast = react_1.useCallback((requiredLevel) => {
        var _a;
        const myLevel = (_a = data === null || data === void 0 ? void 0 : data.location) === null || _a === void 0 ? void 0 : _a.myAccessLevel;
        if (!myLevel) {
            return false;
        }
        else {
            return orderedAcls[myLevel] >= orderedAcls[requiredLevel];
        }
    }, [data]);
    return { data: (_b = (_a = data === null || data === void 0 ? void 0 : data.location) === null || _a === void 0 ? void 0 : _a.myAccessLevel) !== null && _b !== void 0 ? _b : null, loading, error, isAtLeast };
}
exports.useAccessLevel = useAccessLevel;
function mockAccessLevelQuery(locationId, myAccessLevel) {
    return {
        request: {
            query: GET_ACCESS_LEVEL_QUERY,
            variables: { locationId },
        },
        result: {
            data: {
                location: {
                    __typename: 'LocationDTO',
                    key: locationId,
                    myAccessLevel,
                },
            },
        },
    };
}
exports.mockAccessLevelQuery = mockAccessLevelQuery;
const GET_ACCESS_LEVEL_QUERY = graphql_tag_1.default `
  query GetAccessLevelQuery($locationId: String!) {
    location(locationId: $locationId) {
      key
      myAccessLevel
    }
  }
`;
//# sourceMappingURL=useAccessLevel.js.map